import { Acumatica } from "../acumatica-field-decorator";
import { AcumaticaEntity } from "./acumatica-entity";

export class DocContact extends AcumaticaEntity {
    @Acumatica() Attention: string | null = null;
    @Acumatica() BusinessName: string | null = null;
    @Acumatica() Email: string | null = null;
    @Acumatica() Phone1: string | null = null;

    constructor(init?: Partial<DocContact>) {
        super();

        if (init) Object.assign(this, init);
    }
}

export class Address extends AcumaticaEntity {
    @Acumatica() AddressLine1: string | null = null;
    @Acumatica() AddressLine2: string | null = null;
    @Acumatica() City: string | null = null;
    @Acumatica() Country: string | null = null;
    @Acumatica() PostalCode: string | null = null;
    @Acumatica() State: string | null = null;

    constructor(init?: Partial<Address>) {
        super();

        if (init) Object.assign(this, init);
    }
}

export class Contact extends AcumaticaEntity {
    // @Acumatica() Attention: string | null = null;
    @Acumatica() CompanyName: string | null = null;
    @Acumatica() DisplayName: string | null = null;
    @Acumatica() JobTitle: string | null = null;
    @Acumatica() Email: string | null = null;
    @Acumatica() Phone1: string | null = null;
    @Acumatica() Phone1Type: string | null = null;
    @Acumatica() Phone2: string | null = null;
    @Acumatica() Phone2Type: string | null = null;
}